'use strict';

var Driver = global.WebSocket || global.MozWebSocket;
if (Driver) {
	module.exports = function WebSocketBrowserDriver(url) {
		return new Driver(url);
	};
} else {
	module.exports = undefined;
}



//////////////////
// WEBPACK FOOTER
// (webpack)-dev-server/~/sockjs-client/lib/transport/browser/websocket.js
// module id = ./node_modules/webpack-dev-server/node_modules/sockjs-client/lib/transport/browser/websocket.js
// module chunks = 3